import { Component, OnInit } from '@angular/core';
import { DropdownListOption } from "../../../../shared/components/search-dropdown/search-dropdown.component";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { TaxYearsService } from "../../../../shared/util/tax-years.service";
import { TaxReturnTypeSubTypeService } from "../../../../shared/util/tax-return-type-subtype.service";
import { Subscription } from 'rxjs';
import { TenantConfigService } from '../../../../shared/services/tenant-config.service';
import { ConfigStateService } from '../../../config/config-state.service';
import { TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'app-tax-return-builder-selector',
    templateUrl: './tax-return-builder-selector.component.html',
    styleUrls: ['./tax-return-builder-selector.component.scss'],
    standalone: false
})
export class TaxReturnBuilderSelectorComponent implements OnInit {

  taxYearOptions: DropdownListOption[];
  taxReturnTypeOptions: DropdownListOption[];

  searchForm: UntypedFormGroup = new UntypedFormGroup({});
  taxYear: UntypedFormControl;
  taxReturnType: UntypedFormControl;
  subscriptions: Subscription[] = [];
  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  yearLabel: string;

  constructor(
    private taxYearsService: TaxYearsService,
    private typeService: TaxReturnTypeSubTypeService,
    private config: ConfigStateService,
    private translocoService: TranslocoService
    ) {
  }

  ngOnInit() {
    this.taxYear = new UntypedFormControl('');
    this.taxYearsService.getTaxYears().subscribe((years: any) => {
      this.taxYearOptions = years;
      const currYr = this.taxYearsService.getCurrentTaxYear();
      this.taxYear = new UntypedFormControl(currYr);
      this.searchForm.addControl("taxYear", this.taxYear);
    });
    this.typeService.getTaxReturnTypes().subscribe((options: any) => {
      this.taxReturnTypeOptions = options;
      const [firstOption] = options;
      this.taxReturnType = new UntypedFormControl(firstOption.value);
      this.searchForm.addControl("taxReturnType", this.taxReturnType);
    });
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
        this.yearLabel = this.uiConfig.config.yearLabel;
        this.translocoService.selectTranslate('year').subscribe(value => this.yearLabel = value);
        this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
      })
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
